import { render, staticRenderFns } from "./ForgotPasswordVerification.vue?vue&type=template&id=507ae150"
import script from "./ForgotPasswordVerification.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordVerification.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordVerification.vue?vue&type=style&index=0&id=507ae150&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports